import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MyButton from '../../../utils/MyButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { clearErrors } from '../../../redux/actions/dataactions';
import { Bar } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';



import { FaArrowLeft, FaCalendarWeek, FaChartBar, FaCheck } from "react-icons/fa";
import './TareasIndicadoresDialog.css';

export class TareasIndicadoresDialog extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      aprobado: {},
      open: false
    };

  };

  handleOpen = () => {
    this.setState({ open: true });
  };


  handleClose = () => {
    this.setState({
      open: false
    });
  };

  calculatePercentages = (progmtosinfra) => {
    if (!progmtosinfra || progmtosinfra.length === 0) {
      return { realizado: 0, sinRealizar: 0 };
    }

    const total = progmtosinfra.length;
    const realizados = progmtosinfra.filter(p => p.realizado === true).length;
    const sinRealizar = total - realizados;
    console.log(realizados);
    console.log(sinRealizar);
    return {
      realizado: (realizados / total) * 100,
      sinRealizar: (sinRealizar / total) * 100
    };
  }

  calculateNumProgs = (progmtosinfra) => {
    if (!progmtosinfra || progmtosinfra.length === 0) {
      return { realizado: 0, sinRealizar: 0 };
    }

    const total = progmtosinfra.length;
    const realizados = progmtosinfra.filter(p => p.realizado === true).length;
    const sinRealizar = total - realizados;

    return {
      realizado: realizados,
      sinRealizar: sinRealizar
    };
  }


  render() {
    const { UI: { loading } } = this.props;
    const { tareas } = this.props.data;
    const { errors } = this.state;
    const percentages = this.calculatePercentages(tareas);
    const totalprog = tareas ? Object.keys(tareas).length : 0
    const numprogs = this.calculateNumProgs(tareas);

    const databar = {
      labels: ['Realizado', 'Sin Realizar'],
      datasets: [
        {

          backgroundColor: [
            "#0962d5",
            "#338bf7",
          ],

          borderWidth: 1,
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff',
          data: [numprogs.realizado,
          numprogs.sinRealizar
          ],
        },
      ],
    };

    const optionsbar = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false, // Oculta la leyenda, que incluye las etiquetas del dataset
      },
      title: {
        display: false, // Oculta el título del gráfico
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false, // Oculta los valores del eje Y
            beginAtZero: true, // Asegúrate de comenzar en cero
          },
        }]
      },
      plugins: {

        tooltip: {
          enabled: false,
          mode: 'index',
          intersect: false,
        },
      },
    };
    const datapie = {
      datasets: [
        {
          data: [percentages.realizado.toFixed(1),
          percentages.sinRealizar.toFixed(1)],
          backgroundColor: [
            "#0962d5",
            "#338bf7",



          ],
          borderWidth: 5,
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff'
        }
      ],
      labels: ['Realizados', 'Sin Realizar']
    };
    const optionspie = {
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      cutoutPercentage: 5,
      layout: { padding: 5 },
      tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        borderWidth: 2,
        borderColor: "#03178C",
        backgroundColor: "#FFF",
        titleFontColor: "#03178C",
        bodyFontColor: "#03178C",
        footerFontColor: "#03178C"
      }
    };
    return (



      <Fragment>

        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">
                Indicadores
              </p>

            </div>
            <div className="dashing-cardicon">
              <FaChartBar color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>


        </div>
        {/* <MyButton tip="Crear Equipo" onClick={this.handleOpen}>
            <FaFirstAid color="#03178C" className="icon-crearcliente"/>
        </MyButton>*/}

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>

              <h2 className='text-aprobado'>¡Programación de Mantenimiento Exitosa!</h2>
            </div>

          ) : (<div>
            <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>Indicadores</DialogTitle>

            <DialogContent>
              <Grid container spacing={3} alignItems="center" justifyContent="center" sx={{ mt: 1 }}>
                {/* Total Tasks Section */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box sx={{
                      backgroundColor: '#03178C',
                      borderRadius: '50%',
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2,
                      boxShadow: 2
                    }}>
                      <FaCalendarWeek color="#FFFFFF" size={24} />
                    </Box>
                    <Box>
                      <Typography variant="body1" color="textSecondary">Número Total de Tareas</Typography>
                      <Typography variant="h4" sx={{ color: '#03178C', fontWeight: 'bold' }}>{totalprog}</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                    Tareas Realizadas Vs Sin Realizar
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                </Grid>

                {/* Bar Chart Section */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 200, display: 'flex', justifyContent: 'center' }}>
                    <Bar options={optionsbar} data={databar} />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: 'center', p: 2, boxShadow: 1, borderRadius: 2, height: '100%' }}>
                        <Typography variant="body2" color="textSecondary">Sin Realizar</Typography>
                        <Typography variant="h5" sx={{ color: '#338bf7', fontWeight: 'bold', mt: 1 }}>{numprogs.sinRealizar}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: 'center', p: 2, boxShadow: 1, borderRadius: 2, height: '100%' }}>
                        <Typography variant="body2" color="textSecondary">Realizadas</Typography>
                        <Typography variant="h5" sx={{ color: '#0962d5', fontWeight: 'bold', mt: 1 }}>{numprogs.realizado}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1, mt: 2 }}>
                    Porcentaje Tareas Realizadas Vs Sin Realizar
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                </Grid>

                {/* Pie Chart Section */}
                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 200, display: 'flex', justifyContent: 'center' }}>
                    <Pie options={optionspie} data={datapie} />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: 'center', p: 2, boxShadow: 1, borderRadius: 2, height: '100%' }}>
                        <Typography variant="body2" color="textSecondary">Realizadas</Typography>
                        <Typography variant="h5" sx={{ color: '#0962d5', fontWeight: 'bold', mt: 1 }}>{percentages.realizado.toFixed(1)}%</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: 'center', p: 2, boxShadow: 1, borderRadius: 2, height: '100%' }}>
                        <Typography variant="body2" color="textSecondary">Sin Realizar</Typography>
                        <Typography variant="h5" sx={{ color: '#338bf7', fontWeight: 'bold', mt: 1 }}>{percentages.sinRealizar.toFixed(1)}%</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </DialogContent>
          </div>)}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>






          </DialogActions>
        </Dialog>
      </Fragment>

    )
  }
}

TareasIndicadoresDialog.propTypes = {

  clienteId: PropTypes.string.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

const mapActionsToProps = { clearErrors };

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
  data: state.data
})



export default connect(mapStateToProps, mapActionsToProps)(TareasIndicadoresDialog);
